import React, { Component } from "react";

class TimetableCard extends Component {
  render() {
    const handleTime = (time) => {
      let hour = time.split(":")[0];
      let min = time.split(":")[1];
      let part = hour > 12 ? "pm" : "am";

      min = (min + "").length === 1 ? `0${min}` : min;
      hour = hour > 12 ? hour - 12 : hour;
      hour = (hour + "").length === 1 ? `0${hour}` : hour;

      return `${hour}:${min} ${part}`;
    };
    return (
      <div className="border shadow-sm p-3 rounded">
        <div className="th-14 th-medium">
          {this.props.data.subject__subject}
        </div>
        <div className="th-12 th-grey">
          {this.props.data.select_class__class_name} -{" "}
          {this.props.data.section__section_name}
        </div>
        <div className="th-12 th-grey">
          {handleTime(this.props.start)} - {handleTime(this.props.end)}
        </div>
        <div className="th-12  th-grey">
          {this.props.data.sub_teacher__first_name}{" "}
          {this.props.data.sub_teacher__last_name}
        </div>
      </div>
    );
  }
}
export default TimetableCard;
